import React from 'react';
import PropTypes from 'prop-types';
import SectionHeading from '../SectionHeading/SectionHeading';

const CanIGoFasterMessage = (props) => {
  if (props.isAddressSelected && !props.ufbAvailable && props.availablePlans.length > 0) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <SectionHeading
              title={'Can I go faster?'}
              description={
                'We\'ve done some checks on your address and it looks like this is the fastest' +
                ' speed available at your new place for now.'
              }
              titleClassName={'address-search-section-title'}
            >
              You can always come back and upgrade via our dashboard when Fibre is available at your new place.
            </SectionHeading>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

CanIGoFasterMessage.propTypes = {
  isAddressSelected: PropTypes.bool.isRequired,
  availablePlans: PropTypes.arrayOf(PropTypes.object).isRequired,
  ufbAvailable: PropTypes.bool
};

export default CanIGoFasterMessage;



/** WEBPACK FOOTER **
 ** ./src/components/Change/CanIGoFasterMessage.js
 **/